/* Guardar un archivo generado en la app, en las dos plataformas:
 *  - Navegador / PC: descarga directa.
 *  - App nativa (Android): se escribe en el cache y se abre el diálogo nativo
 *    de "Compartir" (en nativo no existe la descarga del navegador).
 */
import { Capacitor } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

/** Quita caracteres inválidos para nombres de archivo. */
export function sanitizarNombre(nombre: string): string {
  return (nombre || "archivo").replace(/[\\/:*?"<>|]+/g, "_").trim() || "archivo";
}

/** App nativa: escribe el archivo en el cache y abre "Compartir".
 *  @param texto true si `data` es texto (UTF-8); false si es base64. */
export async function compartirEnNativo(archivo: string, data: string, titulo: string, texto = false): Promise<void> {
  const { uri } = await Filesystem.writeFile({
    path: archivo,
    data,
    directory: Directory.Cache,
    ...(texto ? { encoding: Encoding.UTF8 } : {}),
  });
  await Share.share({ title: titulo, url: uri, dialogTitle: titulo });
}

/** Guarda un archivo de texto (descarga en navegador, "Compartir" en nativo). */
export async function guardarTexto(archivo: string, contenido: string, tipo: string, titulo: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await compartirEnNativo(archivo, contenido, titulo, true);
    return;
  }
  const url = URL.createObjectURL(new Blob([contenido], { type: tipo }));
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = archivo;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  // Se libera después: algunos navegadores leen el blob de forma asíncrona.
  window.setTimeout(() => URL.revokeObjectURL(url), 10000);
}
